angular.module("jv.totango", [])
.factory('jvTotango', ['$window', 
	function($window) {
		return {
			track : function(type, caller) {
				if (angular.isDefined($window.totango) && $window.enableTotango) {
					$window.totango.track(type, caller);
					if (_jvFe) {
						/* 
						 * _jvFe only shows company settings that is turned on.  We will need to convert
						 * the missing value to false.  In addition, we track only certain company settings.
						 */
						var org = {};
						org.reLat = !!_jvFe.reLat; // Reject Later
						org.ofApp = !!_jvFe.ofApp; // Offer approval
						org.joApp = !!_jvFe.joApp; // Job approval
						org.eajve = !!_jvFe.eajve; // Approve/reject by email
						org.trlc = !!_jvFe.trlc; // trialCompany
						org.srtShd = !!_jvFe.srtShd; // smartScheduler
						org.olkAi = !!_jvFe.olkAi; // outlookApi
						org.ggAi = !!_jvFe.ggAi; // googleApi
						org.ptlin = !!_jvFe.ptlin; // postToLinkedIn
						org.lincsa = !!_jvFe.lincsa; // linkedInCSA
						org.ocp = !!_jvFe.ocp; // ofccp
						org.ptpl = !!_jvFe.ptpl; // personal email templates
						org.dcsn = !!_jvFe.dcsn; // docusign
						org.dncws = !!_jvFe.dncws; // DOTNET CWS
						org.newcws = !!_jvFe.newcws; // New CWS
						org.coLang = !!_jvFe.coLang; // language packs
						org.cofid = !!_jvFe.cofid; // confidential requisitions
						org.eeSync = !!_jvFe.eeSync; // enterprise employee sync
						org.bgck = !!_jvFe.bgck; // background check
						org.rbcf = !!_jvFe.rbcf; // role based custom fields
						org.indd = !!_jvFe.indd; // indeed job board distribution
						org.gldr = !!_jvFe.gldr; // Glassdoor job distribution
						org.twtr = !!_jvFe.twtr; // Twitter job distribution
						org.lkdin = !!_jvFe.lkdin; // LinkedIn job distribution
						org.nrpt = !!_jvFe.nrpt; // new reports
						org.orpt = !!_jvFe.orpt; // old reports
						org.vido = !!_jvFe.vido; // Jobvite video
						org.eeo = !!_jvFe.eeo; // EEO
						org.oflt = !!_jvFe.oflt; // Offer Letters
						org.dnswfl = !!_jvFe.dnswfl; // do not skip workflow
						org.sso = !!_jvFe.sso; // single sign on
						org.fldm = !!_jvFe.fldm; // field mapping
						org.hmcv = !!_jvFe.hmcv; // hiring manager candidate visibility
						org.Engage = !!_jvFe.eng; // Engage
						org.Hire = !!_jvFe.hire; // Hire
						org.Onboard = !!_jvFe.onb; // Onboarding
						org.ocpp = !!_jvFe.ocpp; // OFCCP pre-apply
						org.hcd = !!_jvFe.hcd; // hired candidate data
						org.caf = !!_jvFe.caf; // custom apply forms
						org.ml = !!_jvFe.ml; // multiple locations
						org.rl = !!_jvFe.rl; // remote locations
						org.mfem = !!_jvFe.mfem; // make field elections mandatory
						org.jvb = !!_jvFe.jvb; // Jobvite Brand
						org.udc = !!_jvFe.udc; // redshift UDC enabled
						org.ste = !!_jvFe.ste; // ShareThis enabled
						org.gdcs = !!_jvFe.gdcs; // GDPR application consent in use
						org.gdrt = !!_jvFe.gdrt; // GDPR application retention in use
						org.eeo2q = !!_jvFe.eeo2q; //Separate Ethnicity And Race Questions enabled
						org.eeo1q = !!_jvFe.eeo1q; //Common Ethnicity And Race Question enabled
						org.anDash = !!_jvFe.anDash; // Analytics Dashboard
						org.awlirsm = !!_jvFe.awlirsm; // Apply With Linkedin Enabled
						org.lirsc =!!_jvFe.lirsc;     //LinkedIn RSC Enabled
						org.liprof = !!_jvFe.liprof;  //LinkedIn RSC profile Enabled
						org.li1clck = !!_jvFe.li1clck; // LinkedIn RSC OneClick Enabled
						org.listub = !!_jvFe.listub;   // LinkedIn RSC Stub profile Enabled
						org.limail = !!_jvFe.limail;  // LinkedIn RSC InMail Enabled
						org.linotes = !!_jvFe.linotes;  // LinkedIn RSC InNotes Enabled
						org.liats = !!_jvFe.liats;   // LinkedIn RSC InATS Enabled	
						org.crle = !!_jvFe.crle; // Custom Roles UI admin enabled
						org.selfSchd = !!_jvFe.selfSchd; // self scheduling enabled
						org.eia = !!_jvFe.eia; //Indeed Apply
						org.eiia = !!_jvFe.eiia; //Indeed Apply
						org.elld = !!_jvFe.elld; // linkedin limited job board distribution
						/* org: {'attribute_api_name':'attribute_value'} e.g. {'joApp' : 'true'} */
						$window.totango.setAccountAttributes(org);
					}
					
				}
			},
			module: {
				reporting: 'Reporting',
				video: 'Video',
				jobvite: 'Jobvite',
				pipeline: 'Pipeline',
				campaign: 'Campaign',
				candidate: 'Candidate',
				recruiter: 'Recruiter',
				requisitions: 'Requisitions',
				engage: 'Engage'
			}
		};
}]);
